/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V1TemplateReport {
    'name'?: string;
    'status'?: string;
    'message'?: string;
    'missingFields'?: Array<string>;
    'missingRequiredFields'?: Array<string>;
    'recipientCount'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "missingFields",
            "baseName": "missingFields",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "missingRequiredFields",
            "baseName": "missingRequiredFields",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "recipientCount",
            "baseName": "recipientCount",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return V1TemplateReport.attributeTypeMap;
    }

    public constructor() {
    }
}

